import { render } from "./PostPicker.vue?vue&type=template&id=4b6ec418&scoped=true&ts=true"
import script from "./PostPicker.vue?vue&type=script&lang=ts"
export * from "./PostPicker.vue?vue&type=script&lang=ts"

import "./PostPicker.vue?vue&type=style&index=0&id=4b6ec418&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6ec418"]])

export default __exports__